import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { IStartPageInfoProps } from "../types";
import Link from "next/link";
import useCenterIdOpenPages from "@portal/hooks/useCenterIdOpenPages";

const DEFAULT_LOWER_PERCENT_LIMIT = "0,55";
const DEFAULT_HIGH_PERCENT_LIMIT = "1,15";

const SPN_LOWER_PERCENT_LIMIT = "0,65";
const SPN_HIGH_PERCENT_LIMIT = "1,8";

export const StartPageInfo = ({ isDefaultLanguage }: IStartPageInfoProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  const centerId = useCenterIdOpenPages();

  const lowerLimit = centerId === "2811" || centerId === "3601" ? SPN_LOWER_PERCENT_LIMIT : DEFAULT_LOWER_PERCENT_LIMIT;
  const higherLimit = centerId === "2811" || centerId === "3601" ? SPN_HIGH_PERCENT_LIMIT : DEFAULT_HIGH_PERCENT_LIMIT;

  return (
    <ul className="p-3 space-y-2 border dark:border-blueBorderDark rounded-lg bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark list-disc list-inside">
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_A}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_H}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_B}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_C}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_D}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_E}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_F}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_G}</Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_I}</Typography>
        <Link href="/funds" className="text-blueHighlighted">
          her
        </Link>
      </li>
      <li>
        <Typography variant="BodySpan">
          {texts.PAGE_0_INFO_TEXT_J.replaceAll("$LOWER_PRECENT_LIMIT", lowerLimit).replaceAll(
            "$HIGHER_PRECENT_LIMIT",
            higherLimit,
          )}
        </Typography>
      </li>
      <li>
        <Typography variant="BodySpan">{texts.PAGE_0_INFO_TEXT_K}</Typography>
      </li>
    </ul>
  );
};
